import { Department } from "../department";
import { FormatIdentifier, QuoteBehaviorKinds } from "../format";
import { Patient } from "../patient";
import { User } from "../user";
import {
  EditPhaseKinds,
  DocumentEditBehavior,
  DocumentButtonControl,
  RegisterAlertKinds,
  DocumentEditToolControl,
  ExternalComment,
  DocumentCollaborationSupplement,
  DocumentParameterContainer,
  DocumentCollaborationBehavior,
  EditRuleSet,
  DocumentEditOperation,
} from ".";

export class DocumentAttributes {
  constructor(
    public patient: Patient,
    public department: Department,
    public format: FormatIdentifier,
    public createdDate: Date,
    public isTemporary: boolean,
    public isFixed: boolean,
    public note: string,
    public temporaryNote: string,
    public systemKey: string,
    public linkKey: string,
    public orderNo: string,
    public institutionNo: string,
    public regionalInstitutionNo: string,
    public hisInfoGetterParameter: string,
    public shouldConfirmToSendCost: boolean,
    public shouldSendCost: boolean,
    public isDeleted: boolean,
    public defaultCopies: number,
    public defaultScale: number,
    public quotedDocumentId: number,
    public copiedDocumentId: number,
    public executionMode: string,             // 保存時に実行モードを記録する必要があるため編集時はフロントでも保持.本プロパティを見て振る舞いを変えたりしない事.
    public isExtendedPagePositionSelectable: boolean,
    public phases: EditPhaseKinds[],
    public behavior: DocumentEditBehavior,
    public orderUser: User,
    public attendingUser: User,
    public isRegisterableRegisteredDocumentAsTemporary: boolean,
    public isPrintableRegisteredDocumentAsTemporary: boolean,
    public buttonControl: DocumentButtonControl,
    public editToolControl: DocumentEditToolControl,
    public shouldSendToHis: boolean,
    public ignoreFixKey: string,
    public isDocumentNoteEdited: boolean,
    public isVirtual: boolean,
    public registerAlertKind: RegisterAlertKinds,
    public quoteBehaviorKind: QuoteBehaviorKinds,
    public externalComments: ExternalComment[],
    public collaborationSupplement: DocumentCollaborationSupplement,
    public parameterContainer: DocumentParameterContainer,
    public collaborationBehavior: DocumentCollaborationBehavior,
    public editRuleSet: EditRuleSet,
    public editOperation: DocumentEditOperation,
  ) {
  }
  
  clone(): DocumentAttributes {
    return new DocumentAttributes(
      this.patient,               // TODO:マスタ情報の中身を更新する事はありえないのでclone()しない.(entityのプロパティをreadonlyにしたい)
      this.department,            // TODO:マスタ情報の中身を更新する事はありえないのでclone()しない.(entityのプロパティをreadonlyにしたい)
      this.format,                // TODO:マスタ情報の中身を更新する事はありえないのでclone()しない.(entityのプロパティをreadonlyにしたい)
      new Date(this.createdDate),
      this.isTemporary,
      this.isFixed,
      this.note,
      this.temporaryNote,
      this.systemKey,
      this.linkKey,
      this.orderNo,
      this.institutionNo,
      this.regionalInstitutionNo,
      this.hisInfoGetterParameter,
      this.shouldConfirmToSendCost,
      this.shouldSendCost,
      this.isDeleted,
      this.defaultCopies,
      this.defaultScale,
      this.quotedDocumentId,
      this.copiedDocumentId,
      this.executionMode,
      this.isExtendedPagePositionSelectable,
      this.phases,
      this.behavior,
      this.orderUser,
      this.attendingUser,
      this.isRegisterableRegisteredDocumentAsTemporary,
      this.isPrintableRegisteredDocumentAsTemporary,
      this.buttonControl,
      this.editToolControl,
      this.shouldSendToHis,
      this.ignoreFixKey,
      this.isDocumentNoteEdited,
      this.isVirtual,
      this.registerAlertKind,
      this.quoteBehaviorKind,
      this.externalComments,
      this.collaborationSupplement,
      this.parameterContainer,
      this.collaborationBehavior,
      this.editRuleSet,
      this.editOperation,
    );
  }

  forceOverwrite(source: DocumentAttributes): void {
    this.patient = source.patient;
    this.department = source.department;
    // format
    this.createdDate = new Date(source.createdDate);
    this.isTemporary = source.isTemporary;
    this.isFixed = source.isFixed;
    this.note = source.note;
    this.temporaryNote = source.temporaryNote;
    this.systemKey = source.systemKey;
    this.linkKey = source.linkKey;
    this.orderNo = source.orderNo;
    this.institutionNo = source.institutionNo;
    this.regionalInstitutionNo = source.regionalInstitutionNo;
    this.hisInfoGetterParameter = source.hisInfoGetterParameter;
    this.shouldConfirmToSendCost = source.shouldConfirmToSendCost;
    this.shouldSendCost = source.shouldSendCost;
    this.isDeleted = source.isDeleted;
    // defaultCopies
    // defaultScale
    this.quotedDocumentId = source.quotedDocumentId;
    this.copiedDocumentId = source.copiedDocumentId;
    // executionMode
    this.isExtendedPagePositionSelectable = source.isExtendedPagePositionSelectable;
    this.phases = source.phases;
    this.behavior = source.behavior;
    this.orderUser = source.orderUser;
    this.attendingUser = source.attendingUser;
    this.isRegisterableRegisteredDocumentAsTemporary = source.isRegisterableRegisteredDocumentAsTemporary;
    this.isPrintableRegisteredDocumentAsTemporary = source.isPrintableRegisteredDocumentAsTemporary;
    this.buttonControl = source.buttonControl;
    this.editToolControl = source.editToolControl;
    this.shouldSendToHis = source.shouldSendToHis;
    this.ignoreFixKey = source.ignoreFixKey;
    this.isVirtual = source.isVirtual;
    this.registerAlertKind = source.registerAlertKind;
    this.quoteBehaviorKind = source.quoteBehaviorKind;
    this.externalComments = source.externalComments;
    this.collaborationSupplement = source.collaborationSupplement;
    this.parameterContainer = source.parameterContainer;
    this.collaborationBehavior = source.collaborationBehavior;
    this.editRuleSet = source.editRuleSet;
    this.editOperation = source.editOperation;
  }
}
